// YERİ: src/app/domains/website/core/chrome.store.ts
// Üst menünün AÇIK/KAPALI durumu.
//
// Neden bileşenin içinde değil de burada:
//
//  1. Arka sayfayı karartan perde, menünün İÇİNDE çizilemez. Menü kabuğunda
//     `backdrop-filter` var (buzlu cam) ve backdrop-filter, altındaki
//     `position: fixed` elemanlar için içeren blok oluşturur — perde
//     viewport'a değil menü kutusuna göre konumlanır, yani yalnız menü şeridini
//     kaplar. `absolute` + 100vh ise sayfanın kaydırma yüksekliğini büyütür
//     (sayfa sonunda boşluk). Perde bu yüzden web-layout'ta, menünün DIŞINDA
//     çizilir; durumu paylaşmak için bu store var.
//
//  2. Rota değişince menü kapanmalı. Tek yerde (burada) dinlemek, hem menüde
//     hem perdede ayrı ayrı dinlemekten güvenli.

import { Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MktChromeStore {
  private router = inject(Router);

  /** Açık mega menünün sırası — hiçbiri açık değilse null. */
  readonly openMenu = signal<number | null>(null);

  /** Mobil çekmece açık mı. */
  readonly mobileOpen = signal(false);

  /**
   * Dil listesi açık mı.
   *
   * Perdeye DAHİL DEĞİL: küçük bir açılır liste için sayfayı karartmak
   * gereğinden ağır durur. Dışarı tıklayınca kapanması bileşende, dokümanı
   * dinleyerek yapılıyor.
   */
  readonly langOpen = signal(false);

  /** Perde: ikisinden biri açıksa arka sayfa kararır + bulanıklaşır. */
  readonly overlayOpen = computed(() => this.openMenu() !== null || this.mobileOpen());

  constructor() {
    // Menüden bir bağlantıya tıklandığında sayfa DEĞİŞİR ama menü açık kalırsa
    // ziyaretçi arkada sayfanın değiştiğini göremez — tıklamanın işe yaramadığını
    // sanır. Her gezinmede kapatıyoruz.
    //
    // NavigationEnd (paramMap değil): vitrin rotası catch-all ('**'); aynı
    // bileşende kalındığı için paramMap bir daha tetiklenmez.
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd), takeUntilDestroyed())
      .subscribe(() => this.closeAll());
  }

  closeAll(): void {
    this.openMenu.set(null);
    this.mobileOpen.set(false);
    this.langOpen.set(false);
  }
}
